<template>
  <div class="swiper-container event_banner">
    <swiper class="swiper-wrapper"
            :slides-per-view="1"
            :space-between="50"
            :pagination="{el: '#promotion-banner-pagination', type: 'fraction'}"
            @imagesReady="$emit('loadPromotionBannerImage')"
    >
      <template v-for="banner in promotionBanners" :key="banner.bannerId">
        <swiper-slide class="swiper-slide bn_item" >
          <a @click.prevent="moveToPromotionDetail(banner.bannerId)" href="#" class="event_banner_link">
            <img :src="banner.bannerImageUrl" alt="" class="event_banner_img">
          </a>
        </swiper-slide>
      </template>
    </swiper>
    <div class="pagination_area">
      <div class="swiper-pagination pagination" id="promotion-banner-pagination"></div>
    </div>
    <span class="swiper-notification" aria-live="assertive" aria-atomic="true"></span>
  </div>

</template>

<script>
  import {defineComponent} from "vue";
  // import Swiper core and required modules
  import SwiperCore, {A11y, Navigation, Pagination, Scrollbar} from 'swiper';
  // Import Swiper Vue.js components
  import {Swiper, SwiperSlide} from 'swiper/vue';
  // Import Swiper styles
  import 'swiper/swiper.scss';
  import 'swiper/components/navigation/navigation.scss';
  import 'swiper/components/pagination/pagination.scss';
  import 'swiper/components/scrollbar/scrollbar.scss';
  import router from "@/router";
  import {NamedRouting} from "@/domain/utils/NamedRouting";

  // install Swiper modules
  SwiperCore.use([Navigation, Pagination, Scrollbar, A11y]);

  export default defineComponent({
    name: 'promotion-banner-component',
    props: ['promotionBanners'],
    components: {
      Swiper,
      SwiperSlide,
    },
    methods: {
      moveToPromotionDetail(bannerId) {
        router.push(new NamedRouting('PromotionDetailView', {bannerId: bannerId}));
      },
    }
  });
</script>